export default __webpack_public_path__ + "static/media/sh-cancel.c7472748.png";